module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "prologue"
    }
  }, [_c('img', {
    staticClass: "imagefw",
    attrs: {
      "alt": "Images",
      "src": "images/common1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "prologue"
    }
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("PROLOGUE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At first, all she felt was the cold.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each crystal of snow pierced her bare skin, stinging like an electric volt. A sensation so violent, so torturous. Frigid wetness seeped through the fabric of her pretty red dress. Her body tried to double into itself, to search for what little internal warmth lingered in this coffin of cold.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then the coldness was gone. In its place a heaviness, a numbness remained.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She tried desperately to move but couldn’t. The wet snow pressed on her body. Forcing her down. Pushing her on all sides. Unseen hands dragging her away, away from the light, from the air, from life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fight. She had to fight. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("This can’t be the end,")]), _vm._v(" her brain screamed.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prologue"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Desperately she tried to force open her ice-crusted eyelids, but the weight of the snow had created a mask, encasing her face, her head, and her body.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She concentrated on her fingers. It took every ounce of energy to connect her brain with her right hand, to will her knuckles to bend ever so slightly. She had to free herself. She forced her hand to move, to scrape at the icy blanket smothering her. But each little movement caused the avalanche of snow to press down harder. To bury her deeper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She moaned, though she knew no one could hear her. Why had she come? Why had she listened?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It seemed impossible that across the yard, people were still drinking steaming mugs of hot cocoa, singing carols, and eating dainty cookies cut into precious holiday shapes. Only minutes ago she had been in the warmth of the house, part of her aunt’s party, accepted, included.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unfair. It was all so unfair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She scraped her fingernails violently against the snow that encased her. Eyes sealed shut, she could visualize her red polished nails clawing at the bright white snow. Someone would pay, she decided. Someone would have to.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“Miss Mary? Is that you, Miss Mary?”")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("She shuddered as the voice on the phone echoed in her head. Why had she answered? She should have known that any call this far from home was trouble. She should have refused the kindly old woman who’d handed the receiver to her. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("“Miss Mary.”")]), _vm._v(" Just by the way her name was said, she should have known. She never should have followed the directions. Never should have left the party. Never should have strayed from the house decorated with candy canes.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Darkness pressed on her. Her thoughts became fuzzy. She could sense that her hand was still reaching, still scratching though the snow, but she felt disconnected from her arm. Disconnected from the world. Deep in the darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the haze of snow and cold, her brain grasped at a sudden sensation, a smell that invaded her muddled thoughts. Peppermint. The spicy aroma surrounded her just as the snow did. The smell came from the necklace of mints she wore around her neck. A string of peppermints meant as a garland for the tree that, earlier in the evening, she had strung around herself instead. A festive gesture of a young, carefree girl. A girl full of life and promise.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("She relaxed her frigid muscles. The smell seemed otherworldly. As if telling her that everything would be all right. That there would be justice. That someone would pay for her misery.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("I will not be forgotten,")]), _vm._v(" she vowed.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6631d670","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 63
// module chunks = 0